import { MembershipCardPage } from '../../types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fromStrapiMembershipCardPage = (strapiData: any): MembershipCardPage => strapiData.attributes

export { fromStrapiMembershipCardPage }